const styles = (theme) => ({
  button: {
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    marginTop: -3,
    color: theme.palette.primary.dark,
  },
});

export default styles;
